import { z } from "zod"
import { http } from "../lib/http"

/**
 * Countries registry HTTP client. Mirrors
 * apps/engine/src/countries/dto.ts. The wizard's step 1 reads the
 * seeded list; the registry page (post-onboarding) drives any later
 * additions.
 */

const audited = {
	createdAt: z.string(),
	updatedAt: z.string(),
}

export const CountryRoleSchema = z.enum(["operating", "sourcing"])
export type CountryRole = z.infer<typeof CountryRoleSchema>

export const CountrySchema = z.object({
	id: z.string(),
	code: z.string(),
	name: z.string(),
	role: CountryRoleSchema,
	...audited,
})
export type Country = z.infer<typeof CountrySchema>

export const listCountries = async (signal?: AbortSignal): Promise<Country[]> => {
	const raw = await http<unknown>("/settings/countries", signal !== undefined ? { signal } : {})
	return z.array(CountrySchema).parse(raw)
}

export interface CreateCountryInput {
	readonly code: string
	readonly name: string
	readonly role: CountryRole
}

export const createCountry = async (
	input: CreateCountryInput,
	signal?: AbortSignal,
): Promise<Country> => {
	const raw = await http<unknown>("/settings/countries", {
		method: "POST",
		json: input,
		...(signal !== undefined ? { signal } : {}),
	})
	return CountrySchema.parse(raw)
}

export const countriesQueryKeys = {
	all: ["countries"] as const,
}
